import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { GlassHouseBrandGroupIndexCardStackBackgroundViewModel } from './glass-house-brand-group-index-card-stack-background-view-model';
import type { GlassHouseBrandGroupCardData } from '../../../../../../../models/print-cards/glass-house/glass-house-brand-group-card-data';

@Component({
  selector: 'app-glass-house-brand-group-index-card-stack-background',
  templateUrl: './glass-house-brand-group-index-card-stack-background.component.html',
  styleUrl: './glass-house-brand-group-index-card-stack-background.component.scss',
  providers: [GlassHouseBrandGroupIndexCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseBrandGroupIndexCardStackBackgroundComponent
  extends CardBackgroundComponent
  implements AfterViewInit
{
  constructor(
    public viewModel: GlassHouseBrandGroupIndexCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: GlassHouseBrandGroupCardData;
}
